import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map'
import { User } from "../_models/user";
import { HttpClient, HttpHeaders, HttpErrorResponse  } from "@angular/common/http";
import { CRMStats, DownloadResult } from "../_models/crmStats";


@Injectable()
export class AuthenticationService {
    public baseUrl: string = '';
    public loginHelper = { present: false, attempts: 0, reset: false, isRegister: false };
    public user: User = new User();
    public resetCode: string;
    public stats = new CRMStats();
    public readyForToken = false;
    public isLocal = false;
    public isTFAS = true;
    
    constructor(private http: HttpClient) {
      this.baseUrl = location.origin + "/";//'';//
      if (this.baseUrl.indexOf("localhost") > 0) {
        this.baseUrl = "https://localhost:44386/";
        this.isLocal = true;
      }
    }

    

    login(username: string, password: string) {
        let headers = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded');
        return this.http.post(this.baseUrl + 'Token', "userName=" + encodeURIComponent(username) +
            "&password=" + encodeURIComponent(password) +
          "&grant_type=password", { headers })
            .map(res => {
                return res;
            });
    }
    userInfo() {
        return this.http.get(this.baseUrl + 'api/Account/UserInfo', this.getHeader())
            .map((res:any) => {
              if (res.Roles.indexOf("TFAS") == 0) {
                this.isTFAS = true;
              }
              else this.isTFAS = false;
              return res;
            });
    }
    register(model:User) {

        return this.http.post(this.baseUrl + 'api/account/register', model, this.getHeader())
            .map((res: Response) => {
                return res;
            })
    }
    reset() {

        return this.http.post(this.baseUrl + 'api/account/resetpassword', { email: this.user.email }, this.getHeader())
            .map((res: Response) => {
                return res;
            })
    }
    doReset() {

        return this.http.post(this.baseUrl + 'api/account/resetfromapp', this.user, this.getHeader())
            .map((res: Response) => {
                return res;
            })
    }
    updateProfile() {

        return this.http.post(this.baseUrl + 'api/account/updateprofile', this.user, this.getHeader())
            .map((res: Response) => {
                return res;
            })
    }
    getHeader() {
        let headers = new HttpHeaders().set('Authorization', 'Bearer ' + this.user.token);
        return { headers };
    }
    logout() {
        // remove user from local storage to log user out
        this.user = new User();
        localStorage.removeItem('currentUser');
    }

    getProgress() {
      return this.http.get(this.baseUrl + 'api/InzuzoCRMStats', this.getHeader())
        .map((res: CRMStats) => {
          return res;
        })
    }

    startLoad(inzuzo:boolean,date:Date) {
      return this.http.get(this.baseUrl + 'api/InzuzoCRM?inzuzo=' + inzuzo + '&current=' + date.getFullYear() + '/' + (date.getUTCMonth() + 1) + '/' + date.getUTCDate(),this.getHeader())
        .map((res: DownloadResult) => {
          return res;
        })
    }
    recordRun(inzuzo: boolean) {
      return this.http.get(this.baseUrl + 'api/CRMRun?inzuzo=' + inzuzo, this.getHeader())
        .map(() => { }).subscribe(() => { });
    }
    analytics() {
      return this.http.get(this.baseUrl + 'api/Service', this.getHeader())
        .map((res: Response) => {
          return res;
        })
    }

    ioLogin() {
      this.readyForToken = true;
      const host = "https://identity.intelliflo.com/core/connect/authorize?";
      const query = "response_type=code&scope=openid%20myprofile%20profile%20client_data%20client_financial_data%20firm_data%20offline_access&client_id=app-3b03a9d-acf-7b9477c6b398485e9c9e4db1ed8d4a23&redirect_uri=https://inzuzo.ideafoundry.uk/api/IntelliflowCallback";
      window.open(host + query, "_blank");
    }
    ioToken() {
      return this.http.get(this.baseUrl + 'api/iotoken', this.getHeader())
        .map((res: Response) => {
          const st = JSON.stringify(res);
          return res;
        })
    }
    ioRefresh(token:any) {
      
      return this.http.post(this.baseUrl + 'api/refresh',token, this.getHeader())
        .map((res: Response) => {
          return res;
        })
    }
    fake(token: any) {
      const upload = { Token: token, AdvisorId: 52869, CRMId: 0, IsInzuzo: true };
      return this.http.post(this.baseUrl + 'api/fake', upload, this.getHeader())
        .map((res: Response) => {
          return res;
        })
    }
    local() {

      return this.http.get(this.baseUrl + 'assets/token.json', this.getHeader())
        .map((res: any) => {
          return res;
        }).subscribe((res:any) => {
          const token = JSON.stringify(res);
          localStorage.setItem("ioToken", token);
        })
    }
    niceerror(error: HttpErrorResponse) {
      let message = "";
      if (error.error) {
        if (error.error.ModelState && error.error.ModelState.Errors) {
          error.error.ModelState.Errors.forEach(a => {
            message += a;
            message += "  ";
          })
          return message;
        }
        if (error.error.Message) {
          return error.error.Message
        }
      }
      return "Something went wrong, sorry";
    }

    dateParam(date: Date) {
      return date.getFullYear() + '/' + (date.getUTCMonth() + 1) + '/' + date.getUTCDate();
    }

}



// WEBPACK FOOTER //
// E:/Release/InzuzoA/InzuzoA/src/app/_services/authentication.service.ts